import { createFileRoute } from '@tanstack/react-router'
import { JobCreation } from '@/features/jobs/job-creation'

export const Route = createFileRoute('/_authenticated/job-creation/')({
  component: JobCreation,
})
